import React from 'react';

const AboutSection = () => {
  return (
    <section className="about-section-home">
      <div className="auto-container">
        <div className="row ">

          <div className="about- col-12 col-md-6">
            <div className="inner-column">
              <div className="sec-title style-two">
                <div className="sub-title">Discover Our Commitment to Comfort and Community</div>
                <h2>
                  About Us <span>Shree Swami Samarth PG</span>
                </h2>
                <div className="separator"></div>
              </div>

              <div className="text">
                <p>
                  Welcome to Shree Swami Samarth PG, where the essence of home meets the convenience of modern living. Nestled in the heart of pune, we take pride in offering more than just accommodation; we provide a sanctuary for those seeking a comfortable and communal living experience.
                </p>
                <p>
                 Established with a passion for creating a warm and inviting space, Shree Swami Samarth PG has become synonymous with quality living. We understand the significance of a place that not only meets your daily needs but also fosters a sense of belonging and connection.
                </p>
              </div>
            </div>
          </div>

          <div className="about-details-image col-12 col-md-6 ">
            <div className="image">
              <img src="./images/about-1.jpg" alt="About Aizen" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;
